"use client";

import React, {useMemo} from "react";
import {Svg} from "react-native-svg";

export type IPrimitiveIcon = {
    height?: number | string;
    width?: number | string;
    fill?: string;
    color?: string;
    size?: number | string;
    stroke?: string;
    as?: React.ElementType;
    className?: string;
    classNameColor?: string;
};

const PrimitiveIcon = React.forwardRef<React.ElementRef<typeof Svg>, IPrimitiveIcon>(
    (
        {
            height,
            width,
            fill,
            color,
            classNameColor,
            size,
            stroke = "currentColor",
            as: AsComp,
            ...props
        },
        ref
    ) => {
        color = color ?? classNameColor;
        const sizeProps = useMemo(() => {
            if (size) return {size};
            if (height && width) return {height, width};
            if (height) return {height};
            if (width) return {width};
            return {};
        }, [size, height, width]);

        let colorProps = {};
        if (fill) {
            colorProps = {...colorProps, fill};
        }
        if (stroke !== "currentColor") {
            colorProps = {...colorProps, stroke};
        } else if (stroke === "currentColor" && color !== undefined) {
            colorProps = {...colorProps, stroke: color};
        }

        if (AsComp) {
            return <AsComp ref={ref} {...props} {...sizeProps} {...colorProps} />;
        }
        return <Svg ref={ref} height={height} width={width} {...colorProps} {...props} />;
    }
);

PrimitiveIcon.displayName = "PrimitiveIcon";

export {PrimitiveIcon};
